import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-back-button',
  templateUrl: './app-back-button.component.html',
  styleUrls: ['./app-back-button.component.scss'],
})
export class AppBackButtonComponent {
  @Input() label: string = 'Back';
  @Input() routerLink: string | any[] = '';
  @Input() customClass: string = '';
  @Output() btnClick = new EventEmitter<MouseEvent>();

  handleClick(event: MouseEvent): void {
    this.btnClick.emit(event);
  }
}
